import AmexGDAChefCard from './AmexGDAChefCard';

export default AmexGDAChefCard;
